module.exports = __webpack_public_path__ + "img/hnz-long-logo.39a52f26.png";